module.exports = __webpack_public_path__ + "img/Pista_1836_2.af148950.png";